import React, { forwardRef } from 'react';
import { Form } from 'react-bootstrap';
import classNames from 'classnames';

const Checkbox = forwardRef((props, ref) => {
    const {
        type,
        id,
        label = null,
        inline = false,
        message = false,
        error = false,
        disabled = false,
        size = 'medium',
        className,
        ...restProps
    } = props;

    const styles = {
        small: 'p-2 sm:text-xs',
        medium: 'p-2.5 text-sm',
        large: 'p-4 sm:text-md',
    };


    return (
        <>
            <Form.Check
                ref={ref}
                type={type}
                label={label ? label : ''}
                disabled={disabled}
                inline={inline || false}
                className={classNames(
                    'mt-3 mb-3',
                    { 'inline-block': inline, 'bg-gray-100': disabled },
                    styles[size],
                    className
                )}
                {...restProps}
            />
            {Boolean(message) && (
                <span
                    className={classNames('mb-2 block text-sm font-medium', {
                        'text-red-700': error,
                    })}
                >
                    {message}
                </span>
            )}
        </>
    );
});

Checkbox.displayName = 'Checkbox';

export default Checkbox;
